<panel>
	<h1>{{ 'sale.unapproved-orders' | translate }}</h1>
	<list-orders
		statusFilter="unapproved"
		[groupBy]="getSalesTeam"
		[subGroupBy]="getSellerName"
		[showSellerName]="false"
        [salesTeamsIds]="selectedTeamId"
		[disabled]="isCompleted"></list-orders> 
</panel>
